import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uniqueId from '../../../../node_modules/lodash/uniqueId';
import { withTranslation } from 'react-i18next';
import isArray from 'lodash/isArray';
import './MultiRadio.scss';

class MultiRadio extends Component {
  constructor(props) {
    super(props);
    const { errors } = props;

    this.state = {
      errors,
    };
  }

  componentDidUpdate(prevProps) {
    const { errors } = this.props;
    if (prevProps.errors !== errors) {
      this.setState({
        errors,
      });
    }
  }

  getRadioButton(radio) {
    const { onChange, checkedValue, className, groupName, disabledList } = this.props;
    const radioId = uniqueId('radioList-item-');

    return (
      <div
        className={`form-check ${radio.disabled || disabledList ? 'disabled' : ''} ${className} ${
          radio.className
        }`}
        key={radioId}>
        <input
          type="radio"
          name={radio.name || groupName}
          key={radio.key}
          className="form-check-input"
          id={radioId}
          value={radio.value}
          checked={radio.value == checkedValue}
          disabled={radio.disabled || disabledList}
          onChange={onChange}
        />
        {radio.customLabel ? (
          React.cloneElement(radio.customLabel, { htmlFor: radioId })
        ) : (
          <label
            className="form-check-label"
            htmlFor={radioId}
            dangerouslySetInnerHTML={{ __html: radio.label }}
          />
        )}
        {radio.childElement && <div dangerouslySetInnerHTML={{ __html: radio.childElement }} />}
      </div>
    );
  }

  render() {
    const { errors } = this.state;
    const { radioList, title, description, infoText } = this.props;

    return (
      <div className="multi-radio">
        {title && <h6 className="title">{title}</h6>}
        {infoText && (!errors || !errors.length) && <span className="info-text">{infoText}</span>}
        {errors ? (
          isArray(errors) ? (
            errors.map((error) => (
              <span className="text-error text-small" key={error}>
                {this.props.t(error)}
              </span>
            ))
          ) : (
            <span className="text-error text-small" key={errors}>
              {this.props.t(errors)}
            </span>
          )
        ) : (
          <div className="description">{description}</div>
        )}
        <div className={title || description || errors ? 'multi-radio-list' : null}>
          {radioList.map((radio) => this.getRadioButton(radio))}
        </div>
      </div>
    );
  }
}

MultiRadio.propTypes = {
  onChange: PropTypes.func.isRequired,
  radioList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  title: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  infoText: PropTypes.string,
  checkedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  className: PropTypes.string,
  groupName: PropTypes.string,
  disabledList: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MultiRadio);
